import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm({ source = "home" }) {
    const [email, setEmail] = useState("");
    const [consent, setConsent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            toast.error("Podaj poprawny adres e-mail.");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(`${API}/waitlist`, {
                email,
                marketing_consent: consent,
                source,
            });
            setDone(true);
            toast.success(res.data.message || "Dziękujemy!");
        } catch (err) {
            toast.error("Coś poszło nie tak. Spróbuj ponownie.");
        } finally {
            setLoading(false);
        }
    };

    if (done) {
        return (
            <div data-testid="waitlist-success" className="rounded-2xl border border-success/30 bg-success/10 p-6 text-center">
                <p className="font-heading text-lg font-bold text-foreground">Jesteś na liście! 🎉</p>
                <p className="mt-1 text-sm text-muted-foreground">Poinformujemy Cię, gdy tylko uruchomimy aplikację.</p>
            </div>
        );
    }

    return (
        <form onSubmit={submit} data-testid="waitlist-form" className="space-y-3">
            <div className="flex flex-col gap-2 sm:flex-row">
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="twoj@email.pl"
                    data-testid="waitlist-email-input"
                    aria-label="Adres e-mail"
                    className="min-w-0 flex-1 rounded-full border border-border bg-card px-5 py-3 text-base text-foreground placeholder:text-muted-foreground focus:border-gr-accent focus:outline-none"
                />
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="waitlist-submit"
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:brightness-110 active:scale-95 disabled:opacity-60"
                >
                    {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Zapisz się <ArrowRight className="h-4 w-4" /></>}
                </button>
            </div>
            <label className="flex items-start gap-2 text-xs text-muted-foreground">
                <input
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    data-testid="waitlist-consent"
                    className="mt-0.5 h-4 w-4 rounded border-border accent-gr-primary"
                />
                <span>Zgadzam się na otrzymywanie informacji marketingowych o premierze Groszownika (RODO).</span>
            </label>
        </form>
    );
}
